export default __webpack_public_path__ + "static/media/i021vp.3e432ab2.webp";